if (typeof window.uploadLambdaFile == "undefined") {
    const authToken = 'ijmlknbowei8u7foaisfjaklspajdf';

    window.uploadLambdaFile = async (file, container, inputName) => {
        let fileNameResponse, response, result;
        try {
            fileNameResponse = await fetch('https://uja8w1a1gj.execute-api.us-east-2.amazonaws.com/api/generate_upload_url', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authToken
                },
                body: JSON.stringify({ "filename": file.name })
            });

            result = await fileNameResponse.json();

            if (result?.upload_url) {
                response = await fetch(result.upload_url, {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'Content-Type': file.type
                    }
                });

                if (response.ok) {
                    let input2 = document.createElement('input');
                    input2.type = 'hidden';

                    // new form: for multiple images, we will append a number to the end of the input name
                    if (inputName === 'measurements_image' || inputName === 'wishlist_image') {
                        input2.name = `${inputName}_s3_key`;
                        input2.value = result.s3_key;
                        container.appendChild(input2);

                        // Only these two fields need cleanup tracking (multi-file remove support)
                        return [input2];
                    } else { // old form: for single image, we will just use the input name, also use s3 url
                        let input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = inputName + '_s3_url';
                        input.value = result.download_url;
                        container.appendChild(input);

                        input2.name = inputName + '_s3_key';
                        input2.value = result.s3_key;
                        container.appendChild(input2);
                    }
                } else {
                    console.error('File upload failed:', response.statusText);
                }
            }
        } catch (error) {
            console.error('Upload error:', error);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.upload-lambda-file').forEach(element => {
            element.addEventListener('change', async function (e) {
                let container = e.target.closest("div");
                let fileNameDisplay = container.querySelector('.file-name-display');
                if (e.target.files[0]) {
                    if (fileNameDisplay) {
                        fileNameDisplay.textContent = e.target.files[0].name;
                    }
                    for (let i = 0; i < e.target.files.length; i++) {
                        window.uploadLambdaFile(e.target.files[i], container, e.target.name)
                    }
                } else if (fileNameDisplay) {
                    fileNameDisplay.textContent = '';
                }
            });
        });
    });
}

// if (typeof window.uploadLambdaFile == "undefined") {
//     const authToken = 'ijmlknbowei8u7foaisfjaklspajdf';

//     window.uploadLambdaFile = async (file, container, inputName) => {
//         let fileNameResponse, response, result;
//         try {
//             // generate the file urls
//             fileNameResponse = await fetch('https://uja8w1a1gj.execute-api.us-east-2.amazonaws.com/api/generate_upload_url', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': authToken
//                 },
//                 body: JSON.stringify({ "filename": file.name })
//             });

//             result = await fileNameResponse.json();

//             if (result?.upload_url) {
//                 // upload the file to presigned s3 url
//                 response = await fetch(result.upload_url, {
//                     method: 'PUT',
//                     body: file,
//                     headers: {
//                         'Content-Type': file.type
//                     }
//                 });

//                 if (response.ok) {
//                     // add the file names to the form input
//                     let input = document.createElement('input');
//                     let input2 = document.createElement('input');
//                     input2.type = 'hidden';

//                     // new form: for multiple images, we will append a number to the end of the input name
//                     if (inputName === 'measurements_image' || inputName === 'wishlist_image') {
//                         const existing = container.querySelectorAll(`input[name^="${inputName}_s3_key"]`).length;
//                         input2.name = `${inputName}_s3_key_${existing}`;
//                     } else { // old form: for single image, we will just use the input name, also use s3 url
//                         input.type = 'hidden';
//                         input.name = inputName + '_s3_url';
//                         input.value = result.download_url;

//                         container.appendChild(input);
//                         input2.name = inputName + '_s3_key';
//                     }
//                     input2.value = result.s3_key;

//                     container.appendChild(input2);
//                 } else {
//                     console.error('File upload failed:', response.statusText);
//                 }
//             }
//         } catch (error) {
//             console.error('Upload error:', error);
//         }
//     }

//     document.addEventListener('DOMContentLoaded', function () {
//         document.querySelectorAll('.upload-lambda-file').forEach(element => {
//             element.addEventListener('change', async function (e) {
//                 let container = e.target.closest("div");
//                 let fileNameDisplay = container.querySelector('.file-name-display');
//                 if (e.target.files[0]) {
//                     if (fileNameDisplay) {
//                         fileNameDisplay.textContent = e.target.files[0].name;
//                     }
//                     // loop through files and upload to s3
//                     for (let i = 0; i < e.target.files.length; i++) {
//                         window.uploadLambdaFile(e.target.files[i], container, e.target.name)
//                     }
//                 } else if (fileNameDisplay) {
//                     fileNameDisplay.textContent = '';
//                 }
//             });
//         });
//     });
// }